import { render, staticRenderFns } from "./ImageAnnotationEditor.vue?vue&type=template&id=4b91ca33&scoped=true"
import script from "./ImageAnnotationEditor.vue?vue&type=script&lang=js"
export * from "./ImageAnnotationEditor.vue?vue&type=script&lang=js"
import style0 from "./ImageAnnotationEditor.vue?vue&type=style&index=0&id=4b91ca33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91ca33",
  null
  
)

export default component.exports